<template>
  <v-main id="cenas">
    <v-container fluid>
      <div>
        <v-btn
          depressed
          color="#D8E0E6"
          class="gray-button pag-btn return-btn"
          to="/home"
          ><v-icon size="10" left>$icon-arrow-left</v-icon> Voltar</v-btn
        >
      </div>
      <v-row style="height: 100%">
        <!-- LEFT COLUMN -->
        <v-col class="col col-5 left-col flex-center">
          <div style="width: 100%">
            <v-row>
              <v-col>
                <v-img
                  src="../assets/images/register.png"
                  aspect-ratio="1"
                  contain
                ></v-img>
              </v-col>
            </v-row>
          </div>
        </v-col>
        <!-- RIGHT COLUMN -->
        <v-col class="col col-7 right-col flex-center">
          <!-- LOGO -->
          <div class="logo">
            <v-img src="../assets/images/logo.svg"></v-img>
          </div>
          <v-row align="center" justify="center" style="margin-top: 80px">
            <v-col class="col col-6">
              <!-- BANNER IMAGE -->
              <v-row class="login-img" align="center" justify="center">
                <v-col
                  class="form-col"
                  style="padding: 24px 12px 0 12px"
                  align="center"
                  justify="center"
                >
                  <v-img
                    src="../assets/images/register.png"
                    aspect-ratio="1.5"
                    contain
                  ></v-img>
                </v-col>
              </v-row>
              <v-row align="center" justify="center">
                <v-col class="form-header">
                  <div class="text-center big-title">
                    Está a um passo de ter a
                    <a>posse de bola.</a>
                  </div>
                  <div class="text-center small-title">
                    Chute os dados para a sua conta e preencha o formulário.
                  </div>
                </v-col>
              </v-row>
              <!-- PHONE -->
              <v-row align="center" justify="center">
                <v-col class="form-col" style="padding-bottom: 4px !important">
                  <PhoneSelect
                    :cols="10"
                    @setPhone="setPhone($event)"
                    ref="refPhone"
                  ></PhoneSelect>
                </v-col>
              </v-row>
              <!-- EMAIL -->
              <v-row align="center" justify="center">
                <v-col class="form-col" style="padding-bottom: 4px !important">
                  <v-text-field
                    filled
                    dense
                    height="48"
                    placeholder="Email"
                    :hide-details="!input.email.error"
                    :error-messages="input.email.errorText"
                    name="username"
                    type="email"
                    class="login-register-text"
                    v-model="input.email.value"
                    :append-icon="
                      input.email.error
                        ? '$icon-circle-error'
                        : input.email.valid
                        ? '$icon-circle-check'
                        : ''
                    "
                    @input="validateEmail(false)"
                    v-bind:class="{
                      'input-success': input.email.valid,
                      'input-error': input.email.error,
                    }"
                  ></v-text-field>
                </v-col>
              </v-row>
              <!-- USERNAME -->
              <v-row align="center" justify="center">
                <v-col
                  class="form-col"
                  style="
                    padding-top: 4px !important;
                    padding-bottom: 4px !important;
                  "
                >
                  <v-text-field
                    filled
                    dense
                    height="48"
                    placeholder="Nome utilizador"
                    :hide-details="!input.username.error"
                    :error-messages="input.username.errorText"
                    name="name"
                    type="text"
                    class="login-register-text"
                    v-model="input.username.value"
                    :append-icon="
                      input.username.error
                        ? '$icon-circle-error'
                        : input.username.valid
                        ? '$icon-circle-check'
                        : ''
                    "
                    @input="validateUsername(false)"
                    v-bind:class="{
                      'input-success': input.username.valid,
                      'input-error': input.username.error,
                    }"
                  ></v-text-field>
                </v-col>
              </v-row>
              <!-- PASSWORD -->
              <v-row align="center" justify="center">
                <v-col
                  class="form-col"
                  style="
                    padding-top: 4px !important;
                    padding-bottom: 4px !important;
                  "
                >
                  <v-text-field
                    filled
                    dense
                    height="48"
                    placeholder="Password"
                    :hide-details="!input.password.error"
                    :error-messages="input.password.errorText"
                    name="password"
                    class="login-register-text"
                    v-model="input.password.value"
                    :append-icon="
                      input.password.error
                        ? '$icon-circle-error'
                        : input.password.valid
                        ? '$icon-circle-check'
                        : ''
                    "
                    @input="validatePassword(false)"
                    v-bind:class="{
                      'input-success': input.password.valid,
                      'input-error': input.password.error,
                    }"
                    :type="showPassword ? 'text' : 'password'"
                    @click:append="showPassword = !showPassword"
                  ></v-text-field>
                </v-col>
              </v-row>
              <!-- Confirm Password -->
              <v-row align="center" justify="center">
                <v-col class="form-col" style="padding-top: 4px !important">
                  <v-text-field
                    filled
                    dense
                    height="48"
                    placeholder="Confirme a password"
                    :hide-details="!input.confirm.error"
                    :error-messages="input.confirm.errorText"
                    name="confirm"
                    class="login-register-text"
                    v-model="input.confirm.value"
                    :append-icon="
                      input.confirm.error
                        ? '$icon-circle-error'
                        : input.confirm.valid
                        ? '$icon-circle-check'
                        : ''
                    "
                    v-bind:class="{
                      'input-success': input.confirm.valid,
                      'input-error': input.confirm.error,
                    }"
                    :type="showPassword ? 'text' : 'password'"
                    @input="validateConfirm(false)"
                    @click:append="showPassword = !showPassword"
                  ></v-text-field>
                </v-col>
              </v-row>
              <!-- TERMS/CONDITIONS-->
              <v-row align="center" justify="center">
                <v-col
                  class="form-col"
                  style="padding: 4px 12px 12px 24px !important"
                >
                  <v-checkbox
                    class="checkbox"
                    v-model="input.terms.value"
                    hide-details
                    label="Ao registar-se, autoriza a BigOdds a processar as suas informações, como descrito no Termos e Condições."
                  ></v-checkbox>
                </v-col>
              </v-row>
              <!-- REGISTER BUTTON -->
              <v-row align="center" justify="center">
                <v-col class="flex-center">
                  <v-dialog max-width="349" v-model="showDialog">
                    <v-card style="overflow: hidden">
                      <v-card-title align="center">
                        Mister, faça uma
                        <a>substituição</a>.
                      </v-card-title>
                      <v-card-text
                        >Contra-ataque em campo. Verifique o seu email.
                        Enviamos-lhe um link de confirmação do seu
                        registo.</v-card-text
                      >
                      <v-card-actions>
                        <v-row
                          align="center"
                          justify="center"
                          style="margin-bottom: 12px"
                        >
                          <v-btn
                            large
                            depressed
                            color="primary"
                            class="regular-btn"
                            to="/login"
                            >Ir para página de Login</v-btn
                          >
                        </v-row>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                  <v-btn
                    large
                    depressed
                    color="primary"
                    class="regular-btn"
                    :loading="loading"
                    @click="validate()"
                    >Registar</v-btn
                  >
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
    <v-snackbar v-model="snackbar" :timeout="snackBarTimeout" color="error">{{
      errorText
    }}</v-snackbar>
  </v-main>
</template>

<style scoped>
.v-main {
  height: calc(100vh - 2px);
  padding: 0px 256px 0px 0px;
  position: absolute;
  width: 100vw;
  top: -14px;
  padding: 0 !important;
  left: 0;
}
.container {
  height: 100%;
  padding: 0 !important;
}
.left-col {
  /*flex: 0 0 45%;
  max-width: 45%;*/
}
.return-btn {
  position: fixed;
  top: 24px;
  left: 32px;
  font-family: Gilroy-SemiBold;
  font-size: 14px;
  line-height: 24px;
  color: #9aabb8;
  text-transform: capitalize;
  width: 176px;
  z-index: 99;
}
.right-col {
  /*flex: 0 0 55%;
  max-width: 55%;*/
  background-color: #ffffff;
}
.form-header {
  flex: 0 0 300px;
  max-width: 300px;
}
.big-title {
  font-family: Gilroy-SemiBold;
  font-size: 20px;
  line-height: 24px;
}
.small-title {
  font-family: Gilroy-SemiBold;
  color: #6d818f;
  font-size: 14px;
  line-height: 16px;
}
.v-list-item {
  min-height: initial !important;
}
.light-text {
  color: #bcc5cc !important;
  font-size: 12px;
  line-height: 16px;
}
.align-bottom {
  margin-top: 0;
}
.v-image >>> .v-responsive__sizer {
  max-height: 250px !important;
}
.logo {
  position: absolute;
  left: calc(72.5% - 31px);
  top: 136px;
}
.login-img {
  display: none;
}
.checkbox {
  margin-top: 0;
}
.checkbox >>> .v-label {
  color: #bcc5cc;
  font-family: Gilroy-SemiBold;
  font-size: 11px;
  line-height: 16px;
}
.checkbox >>> .v-icon {
  color: #d8e0e6;
}
.form-col {
  flex: 0 0 380px;
  max-width: 380px;
}
@media only screen and (max-width: 768px) {
  .left-col {
    display: none;
  }
  .right-col {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .login-img {
    display: flex;
  }
  .return-btn {
    width: 106px;
  }
  .form-col {
    flex: 0 0 90%;
    max-width: 90%;
  }
  .logo {
    position: absolute;
    left: 50%;
    top: 84px;
  }
  .logo .v-image {
    position: relative;
    left: -50%;
  }
}
.theme--light.v-btn.v-btn--disabled:not(.v-btn--flat):not(.v-btn--text):not(
    .v-btn--outlined
  ) {
  background-color: #26ab5e !important;
  color: #ffffff !important;
}
.v-btn:not(.v-btn--round).v-size--large {
  height: 48px;
}
</style>

<script>
import { FirebaseApp } from "../auth";
import ApiService from "@/services/api.service";
import PhoneSelect from "@/components/PhoneSelect.vue";

export default {
  props: {
    source: String,
  },
  components: { PhoneSelect },
  data: () => ({
    errorText: "",
    showDialog: false,
    showPassword: false,
    snackbar: false,
    snackBarTimeout: 3000,
    loading: false,
    input: {
      phone: {
        prefix: "",
        value: "",
        valid: false,
        error: false,
        errorText: "",
        key: 0,
      },
      email: {
        value: "",
        valid: false,
        error: false,
        errorText: "",
      },
      username: {
        value: "",
        valid: false,
        error: false,
        errorText: "",
      },
      password: {
        value: "",
        valid: false,
        error: false,
        errorText: "",
      },
      confirm: {
        value: "",
        valid: false,
        error: false,
        errorText: "",
      },
      terms: {
        value: false,
        valid: false,
        error: false,
        errorText: "",
      },
    },
    empty: {
      value: "",
      valid: false,
      error: false,
      errorText: "",
    },
    rules: {
      required: (v) => !!v || "Este campo é obrigatório",
      min: (v) => v.length >= 8 || "Min 8 characters",
      emailMatch: (v) => /.+@.+\..+/.test(v) || "Email inválido",
    },
    passwordRules: [
      (v) => !!v || "Password is required",
      (v) => (v && v.length >= 5) || "Password must have 5+ characters",
      (v) => /(?=.*[A-Z])/.test(v) || "Must have one uppercase character",
      (v) => /(?=.*\d)/.test(v) || "Must have one number",
      (v) => /([!@$%])/.test(v) || "Must have one special character [!@#$%]",
    ],
  }),
  methods: {
    validate() {
      const validPhone = this.validatePhone(true);
      const validEmail = this.validateEmail(true);
      const validUser = this.validateUsername(true);
      const validPass = this.validatePassword(true);
      const validConfirm = this.validateConfirm(true);
      if (validPhone && validEmail && validUser && validPass && validConfirm) {
        this.register();
      }
    },
    validatePhone(fromButton) {
      return this.$refs.refPhone.validatePhone(fromButton);
    },
    validateEmail(fromButton) {
      if (/.+@.+\..+/.test(this.input.email.value)) {
        this.input.email.valid = true;
        this.input.email.error = "";
        return true;
      } else {
        this.input.email.valid = false;
        if (fromButton) {
          this.input.email.error = true;
          this.input.email.errorText = "Email inválido";
        }
        return false;
      }
    },
    validateUsername(fromButton) {
      if (this.input.username.value.length > 0) {
        this.input.username.valid = true;
        this.input.username.error = "";
        return true;
      } else {
        this.input.username.valid = false;
        if (fromButton) {
          this.input.username.error = true;
          this.input.username.errorText = "Campo obrigatório";
        }
        return false;
      }
    },
    validatePassword(fromButton) {
      if (
        this.input.password.value.length > 8 &&
        /(?=.*[A-Z])/.test(this.input.password.value) &&
        /(?=.*\d)/.test(this.input.password.value) &&
        /([!@#$%])/.test(this.input.password.value)
      ) {
        this.input.password.valid = true;
        this.input.password.error = "";
        return true;
      } else {
        this.input.password.valid = false;
        if (fromButton) {
          this.input.password.error = true;
          this.input.password.errorText =
            "Password tem de ter pelo menos 8 caracteres, uma maiúscula, um número e um caracter especial [!@#$%]";
        }
        return false;
      }
    },
    validateConfirm(fromButton) {
      if (
        this.input.password.valid &&
        this.input.confirm.value == this.input.password.value
      ) {
        this.input.confirm.valid = true;
        this.input.confirm.error = "";
        return true;
      } else if (
        this.input.password.valid &&
        this.input.confirm.value != this.input.password.value
      ) {
        this.input.confirm.valid = false;
        if (fromButton) {
          this.input.confirm.error = true;
          this.input.confirm.errorText = "Passwords têm de ser iguais!";
        }
        return false;
      }
    },
    validateTerms(fromButton) {
      if (this.input.terms.value.length) {
        this.input.terms.valid = true;
        this.input.terms.error = "";
        return true;
      } else {
        this.input.terms.valid = false;
        if (fromButton) {
          this.input.terms.error = true;
          this.input.terms.errorText = "Campo obrigatório";
        }
        return false;
      }
    },
    register() {
      this.loading = true;
      FirebaseApp.auth()
        .createUserWithEmailAndPassword(
          this.input.email.value,
          this.input.password.value
        )
        .then((userCredential) => {
          userCredential.user
            .sendEmailVerification()
            .then(() => {
              this.registerUser();
              this.loading = false;
              this.showDialog = true;
              this.input.email = this.empty;
              this.input.username = this.empty;
              this.input.password = this.empty;
              this.input.confirm = this.empty;
            })
            .catch(function (error) {
              console.error(error);
            });
        })
        .catch((error) => {
          this.loading = false;
          if (
            error.code === "auth/wrong-password" ||
            error.code === "auth/user-not-found" ||
            error.code === "auth/invalid-email"
          ) {
            this.errorText = "O email e/ou a password errados";
            this.emailError = true;
          } else if (error.code === "auth/too-many-requests") {
            this.errorText =
              "Demasiadas tentativas sem êxito. Por favor, tente mais tarde.";
            this.snackbar = true;
          } else {
            this.errorText = "Erro ao contactar o servidor. pedimos desculpas!";
            this.snackbar = true;
          }

          console.error(error);
          console.log(this.errorText);
          return false;
        });
    },
    registerUser() {
      ApiService.registerUser(
        this.input.email.value,
        this.input.username.value,
        this.input.phone.value
      ).then(
        (response) => {
          console.log(response.data);
        },
        (error) => {
          console.log(
            (error.response && error.response.data) ||
              error.message ||
              error.toString()
          );
        }
      );
    },
    setPrefix(prefix) {
      this.input.phone.prefix = prefix;
      this.input.phone.key++;
    },
    setPhone(phone) {
      this.input.phone.value = phone;
      this.input.phone.key++;
      console.log(this.input.phone.value);
    },
  },
};
</script>